/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const LogoText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    height="30"
    viewBox="0 0 920 209.33333"
    fill="current"
    {...props}
  >
    <path
      d="M704.39 1090.45h-256.1V297.328h-187v793.122H6.54v178.87h697.85v-178.87"
      style={{
        fill: 'current',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(.13333 0 0 -.13333 0 209.333)"
    />
    <path
      d="M1102.84 636.09c0 109.762-79.94 187-184.28 187-102.99 0-182.94-77.238-182.94-187s79.95-186.988 182.94-186.988c104.34 0 184.28 77.226 184.28 186.988zm-542.02 0c0 201.898 158.54 357.73 357.74 357.73 199.19 0 359.09-155.832 359.09-357.73 0-201.899-159.9-357.738-359.09-357.738-199.2 0-357.74 155.839-357.74 357.738M1593.48 806.828V524.98c0-73.171 52.85-74.531 153.12-69.109V297.328c-245.26-27.109-327.92 44.711-327.92 227.652v281.848h-117.89v168.024h117.89v136.858l174.8 52.85V974.852h153.12V806.828h-153.12M2337.46 636.09c0 113.82-79.95 191.058-188.35 191.058-107.05 0-187-77.238-187-191.058s79.95-191.059 187-191.059c108.4 0 188.35 77.239 188.35 191.059zm174.8 338.762V297.328h-174.8v79.953c-48.78-60.98-121.95-98.929-220.88-98.929-180.21 0-329.28 155.839-329.28 357.738 0 201.898 149.07 357.73 329.28 357.73 98.93 0 172.1-37.941 220.88-98.91v79.942h174.8M2616.71 1269.79h174.8V297.328h-174.8v972.462"
      style={{
        fill: 'current',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(.13333 0 0 -.13333 0 209.333)"
    />
    <path
      d="M704.39 1090.45h-256.1V297.328h-187v793.122H6.54v178.87h697.85v-178.87"
      style={{
        fill: 'current',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(.13333 0 0 -.13333 0 209.333)"
    />
    <path
      d="M1102.84 636.09c0 109.762-79.94 187-184.28 187-102.99 0-182.94-77.238-182.94-187s79.95-186.988 182.94-186.988c104.34 0 184.28 77.226 184.28 186.988zm-542.02 0c0 201.898 158.54 357.73 357.74 357.73 199.19 0 359.09-155.832 359.09-357.73 0-201.899-159.9-357.738-359.09-357.738-199.2 0-357.74 155.839-357.74 357.738M1593.48 806.828V524.98c0-73.171 52.85-74.531 153.12-69.109V297.328c-245.26-27.109-327.92 44.711-327.92 227.652v281.848h-117.89v168.024h117.89v136.858l174.8 52.85V974.852h153.12V806.828h-153.12M2337.46 636.09c0 113.82-79.95 191.058-188.35 191.058-107.05 0-187-77.238-187-191.058s79.95-191.059 187-191.059c108.4 0 188.35 77.239 188.35 191.059zm174.8 338.762V297.328h-174.8v79.953c-48.78-60.98-121.95-98.929-220.88-98.929-180.21 0-329.28 155.839-329.28 357.738 0 201.898 149.07 357.73 329.28 357.73 98.93 0 172.1-37.941 220.88-98.91v79.942h174.8M2616.71 1269.79h174.8V297.328h-174.8v972.462"
      style={{
        fill: 'current',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(.13333 0 0 -.13333 0 209.333)"
    />
    <path
      d="M3502.34 465.82V292.328h-569.16v977.332h562.58v-173.52h-381.19V900.289h348.32V729.422h-348.32V465.82h387.77M4216.24 1096.14h-248.42V292.328h-181.41v803.812H3539.3v173.52h676.94v-173.52M4979.52 782.211c0 181.758-133.3 309.679-304.29 309.679-171.01 0-304.31-127.921-304.31-309.679 0-180.43 133.3-308.34 304.31-308.34 170.99 0 304.29 127.91 304.29 308.34zm-793.07 0c0 276.019 216.78 490.109 488.78 490.109 271.98 0 490.11-214.09 490.11-490.109 0-274.68-218.13-490.109-490.11-490.109-272 0-488.78 215.429-488.78 490.109"
      style={{
        fill: '#f44336',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(.13333 0 0 -.13333 0 209.333)"
    />
    <path
      d="M3502.34 465.82V292.328h-569.16v977.332h562.58v-173.52h-381.19V900.289h348.32V729.422h-348.32V465.82h387.77M4216.24 1096.14h-248.42V292.328h-181.41v803.812H3539.3v173.52h676.94v-173.52M4979.52 782.211c0 181.758-133.3 309.679-304.29 309.679-171.01 0-304.31-127.921-304.31-309.679 0-180.43 133.3-308.34 304.31-308.34 170.99 0 304.29 127.91 304.29 308.34zm-793.07 0c0 276.019 216.78 490.109 488.78 490.109 271.98 0 490.11-214.09 490.11-490.109 0-274.68-218.13-490.109-490.11-490.109-272 0-488.78 215.429-488.78 490.109"
      style={{
        fill: '#f44336',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(.13333 0 0 -.13333 0 209.333)"
    />
  </svg>
);

export default LogoText;
